module.exports = __webpack_public_path__ + "images/beyond-image-carrot.334961c7.png";